export interface GeoResponse {
  ip: string;
  city: string;
  country: string;
  region: string;
  loc: string;
  postal: string;
}

export interface GeoApiResponse {
  status: 'OK' | 'KO';
  info: GeoResponse;
}
